import React from 'react';
import {useField, useFormikContext} from 'formik';

import {Column} from '../layout';
import ErrorMessage from './ErrorMessage';
import './styles.scss';
import AppSelectInput from '../input/app-select-input';
import Icon from '../icon';
import {Icons} from '../../util/icons';
import colors from '../../util/colors';
import {Store} from '../../store';

interface Option {
  value: string;
  label: string;
}

interface AppFormSelectFieldProps extends React.HTMLProps<HTMLInputElement> {
  name: string;
  showErrorMessage?: boolean;
  options: Option[];
  placeholder?: string;
  className?: string;
  handleFormikContext?(formik: any): void;
  inputStyle?: any;
  onChange?(value: any): void;
  error?: string;
  value?: any;
  defaultValue?: any;
}

function AppFormSelectField({
  name,
  showErrorMessage = false,
  options,
  placeholder,
  handleFormikContext,
  className,
  inputStyle,
  onChange,
  error,
  value,
  defaultValue,
}: AppFormSelectFieldProps) {
  const formik = useFormikContext();
  const {
    setFieldTouched,
    setFieldError,
    errors,
    touched,
    submitCount,
    setFieldValue,
    handleChange,
  } = formik;
  const newError =
    typeof error === 'boolean'
      ? Store.getState().strings.value.pt.messages.requiredField
      : error || (errors as any)[name];

  const [field] = useField(name);

  const formikError = (errors as any)[name];
  const visible = (touched as any)[name] || submitCount > 0;

  // Final error (only show if visible)
  const displayError = error ?? (visible ? formikError : undefined);

  if (!!handleFormikContext) {
    handleFormikContext(formik);
  }

  return (
    <Column style={{width: '100%'}}>
      {showErrorMessage && !!displayError && formik.submitCount > 0 && (
        <div className="app-form-field-error-content">
          <Icon
            width="24"
            height="24"
            name={Icons.ALERT_PROBLEM}
            color={colors.alertRed}
          />
          {showErrorMessage && (
            <ErrorMessage error={newError} visible={!!displayError} />
          )}
        </div>
      )}
      <AppSelectInput
        defaultValue={defaultValue || ''}
        inputStyle={inputStyle}
        className={`${className}${
          showErrorMessage &&
          !!displayError &&
          formik.submitCount > 0 &&
          ' invalid-app-form-field'
        }`}
        onBlur={() => setFieldTouched(name)}
        placeholder={placeholder}
        value={value ? value : field.value}
        options={options}
        onChange={
          onChange
            ? (value) => {
                onChange(value);
                setFieldError(name, ''); // this might not be the best solution since it might affect other forms that use this component
                setFieldValue(name, value);
              }
            : (value) => {
                setFieldError(name, ''); // this might not be the best solution since it might affect other forms that use this component
                setFieldValue(name, value);
              }
        }
        error={error ? newError : newError && visible}
      />
    </Column>
  );
}

export default AppFormSelectField;
